import { useContext } from 'react';
import { useConfig } from '../../../../contexts/config-context';
import { FormViewContext } from '../../../../contexts/form-view-context';
import { getResponsiveGrid } from '../../../../utils/responsive-grid';
export function useResponsiveGrid() {
    const { cssMobileLayout, isMobile } = useConfig();
    const form = useContext(FormViewContext);
    return cssMobileLayout && !isMobile && form ? getResponsiveGrid(form) : undefined;
}

//# sourceMappingURL=use-responsive-grid.js.map